import { InputGroup, Position, Tooltip } from "@blueprintjs/core";
import { FormikProps } from "formik";
import { observer } from "mobx-react";
import { StandardFormInput } from "modules/common/components/form/StandardFormInput";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { getFieldLabel } from "modules/common/services/form/fields";
import React from "react";
import { Schema } from "yup";
import { fields, SettingsStoreType } from "../models/settings";
import styles from "./SystemSettings.module.scss";

class Connection1CBase extends React.PureComponent<Connection1CSettingsProps, Connection1CState> {
  constructor(props: any) {
    super(props);

    this.state = { testing: false };
  }

  testConnection = async () => {
    const { store, form } = this.props;
    const values = form.values;

    this.setState({ testing: true });
    try {
      await store.testOneCConnection(values.oneCUrl, values.oneCLogin, values.oneCPassword);
    } finally {
      this.setState({ testing: false });
    }
  };

  render() {
    const { schema } = this.props;

    return (
      <div className="columns">
        <div className={styles.columns}>
          <div className={styles.column}>
            <StandardFormInput
              name={fields.oneCEnabled}
              schema={schema}
              small={true}
              className="planr-form-input"
              inline={false}
            >
              {({ field, form }) => (
                <PlanrButton
                  type="neutral"
                  icon={field.value ? "general-checkbox" : "general-zero-checkbox"}
                  onClick={() => {
                    form.setFieldValue(field.name, !field.value);
                    form.setFieldTouched(field.name, true);
                  }}
                  style={{ marginTop: "-5px" }}
                />
              )}
            </StandardFormInput>
            <StandardFormInput
              name={fields.oneCUrl}
              schema={schema}
              inline={false}
              small={true}
              className="planr-form-input"
              label={
                <span className="planr-input-label-help">
                  {getFieldLabel(fields.oneCUrl, schema, null)} &nbsp;&nbsp;
                  <Tooltip
                    content={
                      <div>
                        <p>Базовый адрес OData-сервиса 1С.</p>
                        <p>{`Пример: https://host/base/odata/standard.odata/`}</p>
                      </div>
                    }
                    position={Position.RIGHT}
                  >
                    <GeneralIcon type="general-question" />
                  </Tooltip>
                </span>
              }
            >
              {({ field }) => (
                <InputGroup
                  id={field.name}
                  className="planr-default-input"
                  {...field}
                  type="text"
                  autoComplete="off"
                  data-lpignore="true"
                />
              )}
            </StandardFormInput>
            <StandardFormInput
              name={fields.oneCLogin}
              schema={schema}
              inline={false}
              small={true}
              className="planr-form-input"
            >
              {({ field }) => (
                <InputGroup
                  id={field.name}
                  className="planr-default-input"
                  {...field}
                  type="text"
                  autoComplete="off"
                  data-lpignore="true"
                />
              )}
            </StandardFormInput>
            {/*
              Осознанно НЕ используем type="password": браузер принимает пару
              «текстовое поле + password» внутри общей формы настроек за форму входа
              и предлагает сохранить логин 1С как учётные данные сайта. Значение
              скрываем через -webkit-text-security (см. styles.maskedInput).
            */}
            <StandardFormInput
              name={fields.oneCPassword}
              schema={schema}
              inline={false}
              small={true}
              className="planr-form-input"
            >
              {({ field }) => (
                <InputGroup
                  id={field.name}
                  className={`planr-default-input ${styles.maskedInput}`}
                  {...field}
                  type="text"
                  autoComplete="off"
                  data-lpignore="true"
                />
              )}
            </StandardFormInput>
            <PlanrButton
              type="dashed"
              onClick={this.testConnection}
              size="small"
              style={{ marginTop: "10px" }}
              disabled={this.state.testing}
            >
              Проверить подключение
            </PlanrButton>
          </div>
        </div>
      </div>
    );
  }
}

export const Connection1CSettings = observer(Connection1CBase);

interface Connection1CState {
  testing: boolean;
}

interface Connection1CSettingsProps {
  schema: Schema<any>;
  store: SettingsStoreType;
  form: FormikProps<any>;
}
